import AgentTimeTrackingComponent from '../AgentTimeTrackingComponent.vue'
import SessionReviewsComponent from '../SessionReviewsComponent.vue'
import UnusualActivityComponent from '../UnusualActivityComponent.vue'
import PersonalTimeTrackingComponent from '../PersonalTimeTrackingComponent.vue'
import DownloadAppComponent from '../DownloadAppComponent.vue'
import AgentSettingsComponent from '../AgentSettingsComponent.vue'
import { AGENT_SETTINGS_ADMIN_EMAILS } from '../agentSettingsAccess'

export default [
    {
        path: '/time-tracking',
        name: 'TimeTracking',
        meta: { layout: 'default', requiresRole: [1], allowedUserIds: [47], requiresManagesUsers: true },
        component: AgentTimeTrackingComponent,
    },
    {
        // Same access as /time-tracking (AgentController::unusualActivity).
        path: '/time-tracking/unusual-activity',
        name: 'UnusualActivity',
        meta: { layout: 'default', requiresRole: [1], allowedUserIds: [47], requiresManagesUsers: true },
        component: UnusualActivityComponent,
    },
    {
        // Same people the API lets review (AgentController::canReviewSessions).
        path: '/time-tracking/reviews',
        name: 'SessionReviews',
        meta: { layout: 'default', requiresRole: [1, 2, 11], allowedUserIds: [47] },
        component: SessionReviewsComponent,
    },
    {
        path: '/time-dashboard',
        name: 'PersonalTimeDashboard',
        meta: { layout: 'default' },
        component: PersonalTimeTrackingComponent,
    },
    {
        path: '/download-app',
        name: 'DownloadApp',
        meta: { layout: 'default' },
        component: DownloadAppComponent,
    },
    {
        path: '/agent-settings',
        name: 'AgentSettings',
        meta: { layout: 'default', allowedEmails: AGENT_SETTINGS_ADMIN_EMAILS },
        component: AgentSettingsComponent,
    },
]
